import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { GroupsState } from '@/store/groups/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'
import formation from './formation'

const Groups: Module<GroupsState, RootState> = {
  state: (): GroupsState => ({
    groups: [],
    pager: {
      current: 1,
      last: 1,
      totalLength: 0,
    },
  }),
  mutations,
  actions,
  getters,
  modules: {
    formation,
  },
};

export default Groups;
